// extracted by mini-css-extract-plugin
export default {"root":"agenda-item_root__Edy9e","list":"agenda-item_list__FLU1l"};